module.exports = "<input type=\"text\" #pickerElement class=\"theme_lpg\">\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/daterange/daterange.component.html
// module id = ogkd
// module chunks = 6